"use client";
import React from "react";
import { LandRegistrationGuideProps } from "./types";
import { CardGridSection } from "../CardGridSection";
import styles from './LandRegistrationGuide.module.css';
import Heading from "@/components/molecules/Heading";
import BupiLink from "@/components/atoms/link";

export const LandRegistrationGuide: React.FC<LandRegistrationGuideProps> = ({
  header,
  cards,
}) => {
  return (
    <section
      className={`${styles["land-registration-guide"]} py-64 md:py-96 -mb-96 pb-96 bg-primary-100 space-y-64 text-[#2B363C] `}
    >
      <header className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-32 mt-[24px]">
        <div
          id="land-registration-guide-title"
        >
          <Heading title={header?.question || ""} />
        </div>
        <div className="flex justify-center flex-col gap-[20px]">
          <div className="text-m-regular" dangerouslySetInnerHTML={{ __html: header?.answer || "" }} />
          <BupiLink
            label={header?.ctaLink?.label || ""}
            url={header?.ctaLink?.url || ""}
            target={header?.ctaLink?.target || "_self"}
            hasIcon
            className="py-16"
          />
        </div>

      </header>

      {cards && <CardGridSection cardItems={cards} />}
    </section>
  );
};
